<template>
  <div class="register-info-container flex justify-space-between">
    <div class="info">
      <h2
        style="font-size: 30px;color: #ffff;  line-height: 1;"
        class="fw-600 m-0 p-0"
      >
        Register receive information
      </h2>
      <p style="color: #ffff; line-height:1.5; " class="mt-10">
        Produce following as be didn't sitting on appeared not he is he upper
        work spread observed, hung spot.
      </p>
      <div class="mt-20">
        <SearchEmail />
      </div>
    </div>
    <img class="desktop" :src="images.Ellipse" alt="" />
  </div>
</template>

<script>
import Ellipse from "@/assets/img/img_edu/Ellipse 119.png";
import SearchEmail from "@/views/components/search/SearchEmail.vue";
export default {
  name: "register-info",
  props: {},
  components: {
    SearchEmail
  },
  created() {},
  data() {
    return {
      images: {
        Ellipse
      }
    };
  }
};
</script>
<style scoped>
.register-info-container {
  padding-top: 50px;
  position: relative;
  background: #3d89ec;
  border-radius: 8px;
}
.info {
  margin: 0 100px 0 60px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .register-info-container {
    padding-top: 0px;
    position: relative;
    background: #3d89ec;
    border-radius: 8px;
  }
  .info {
    margin: 0 20px 0 20px;
  }
}
</style>
